import 'core-js/stable';
import 'regenerator-runtime/runtime';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { loadableReady } from '@loadable/component';
import React from 'react';
// eslint-disable-next-line react/no-deprecated
import { hydrate, render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { App } from 'src/modules/app';
import { initBrowserI18n } from 'src/shared/i18n/browserI18n';
import { NonceProvider } from 'src/shared/providers';

import { ApolloClientProvider } from './ApolloClientProvider';

const BaseApp = () => {
  const emotionCache = createCache({ key: 'emotion' });
  return (
    <HelmetProvider>
      <NonceProvider window={window}>
        <BrowserRouter>
          <CacheProvider value={emotionCache}>
            <ApolloClientProvider>
              <App />
            </ApolloClientProvider>
          </CacheProvider>
        </BrowserRouter>
      </NonceProvider>
    </HelmetProvider>
  );
};

/**
 * Application entrypoint
 */
const main = async () => {
  try {
    const [i18n] = await Promise.all([initBrowserI18n(), loadableReady()]);
    hydrate(<BaseApp />, document.getElementById('root'));
    if (module.hot) {
      // Cleanup any existing event listeners
      i18n.off('reloadedResources');
      // This will reload i18n resources when they change on the filesystem
      i18n.on('reloadedResources', () => {
        render(<BaseApp />, document.getElementById('root'));
      });
      module.hot.accept();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error hydrating application', error);
  }
};

if (document.readyState === 'loading') {
  // Loading hasn't finished yet
  document.addEventListener('DOMContentLoaded', main);
} else {
  void main();
}
